import { useMemo } from 'react';

import useForm from '../utils/useForm';
import VendorService from '../../services/VendorService';

const getSortedVendors = async (loanId) => {
  console.log('loanId', loanId);

  const vendors = await VendorService.getVendors({
    type: ['Tax'],
    loanId,
  });

  if (!vendors) {
    return [];
  }

  return vendors.sort((a, b) => {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
  });
};

const usePropertyVendorForm = (onSubmit, loanId) => {
  const submitHandler = (formValues, actions) => {
    onSubmit(formValues);
    actions.resetForm();
  };

  const fields = useMemo(
    () => [
      {
        title: '',
        fields: [
          {
            title: 'Vendor',
            name: 'vendor_id',
            type: 'fetchableSelect',
            fetchOptions: {
              key: ['vendors', 'Tax'],
              queryFn: () => getSortedVendors(loanId),
              labelKey: 'name',
            },
            required: true,
          },
          {
            title: 'Tax Identification Number',
            name: 'tax_identification_number',
            type: 'text',
            required: true,
          },
          {
            title: 'Tax Year',
            name: 'tax_year',
            type: 'select',
            options: [
              {
                label: '2023',
                value: 2023,
              },
              {
                label: '2024',
                value: 2024,
              },
              {
                label: '2025',
                value: 2025,
              },
            ],
          },
        ],
      },
    ],
    [loanId]
  );

  return useForm({ fields, onSubmit: submitHandler });
};

export default usePropertyVendorForm;
